import React from "react";
 
import "./KeyValueAdministrationPage.scss";

export function KeyValueAdministrationPage() {
    return <div className="keyValueAdministrationPage">
        <h1>KEY VALUE PAGE</h1>
    </div>
}